import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginScreen from "../screens/login/login";
import DashboardIndex from "../screens/dashboard/DashboardIndex";
import React from "react";
import Banner from "./../screens/home/Banner";
import Category from "./../screens/products/category/Category";
import SubCategory from "./../screens/products/sub category/SubCategory";
import Products from "./../screens/products/products/Products";
import ProductForm from "./../screens/products/products/ProductForm";
import Addons from "./../screens/products/addons/Addons";
import Flavour from "./../screens/products/flavour/Flavour";
import PreviewBanner from "./../screens/home/PreviewBanner";
import ProductsImage from "./../screens/products/products/productImage/ProductsImage";
import CategoryDiscount from "./../screens/discount/category-discount";
import ProductDiscount from "./../screens/discount/product-discount";
import Promo from "./../screens/discount/promo";
import HomeRegionSelection from "./../screens/home/home-section/HomeRegionSelection";
import City from "./../screens/region/city/City";
import Location from "./../screens/region/location/Location";
import Shop from "./../screens/region/shop/Shop";
import Dispatch from "./../screens/region/dispatch/Dispatch";
import HomeSection from "./../screens/home/home-section/HomeSection";
import OrderList from "./../screens/order/orderList/OrderList";
import OrderDetails from "./../screens/order/orderList/OrderDetails";
import DispatchPanel from "./../screens/external/dispatch/DispatchPanel";
import ViewDispatchOrder from "./../screens/external/dispatch/ViewDispatchOrder";
import ShopPanel from "./../screens/external/shop/ShopPanel";
import ViewShopOrder from "./../screens/external/shop/ViewShopOrder";
import DriverPanel from "./../screens/external/driver/DriverPanel";
import ViewDriverOrder from "./../screens/external/driver/ViewDriverOrder";
import Discount from "./../screens/discount/discount";
import Chats from "../screens/chats/Chats";
import Bulk from "../screens/bulk/Bulk";
import DeliveryCharges from "../screens/region/city/DeliveryCharges";
import { AdminProvider } from "../components/Admin/Admin";
import Units from "../components/units/Units";
import Weight from "../components/weight/Weight";
import Tax from "../components/tax/Tax";
import CustomerDiscount from "../screens/discount/customer-discount";
import CakeDesigner from "../screens/customDesign/CustomDesign";
import LoginDispatch from "../screens/login/dispatchLogin/DispatchLogin";
import LoginShop from "../screens/login/shopLogin/ShopLogin";
import CustomerPromo from "../screens/discount/customer-promo";
import MainLogin from "../components/MainlLogin/mainLogin";
import SuggestionProduct from "../screens/discount/SuggestionProduct";
import CampaignScreen from "../screens/discount/CampaignScreen";
import Configuration from "../screens/home/home-section/configuration/Configuration";
import SlotBlock from "../screens/home/home-section/slotBlock/SlotBlock";
import SalesReport from "../screens/order/orderList/SalesReport";
import Campaign from "../screens/engagement/campaign/Campaign";
import MenuCreate from "../screens/admin/MenuCreate";
import Role from "../screens/admin/Role";
import Team from "../screens/admin/Team";
import YearlyReport from "../screens/order/orderList/YearlyReport";
import FastDelivery from "../screens/products/products/FastDelivery"
import CategoryCode from "../components/Category-code/Categorycode";
import FlatPrice from "../screens/discount/FlatPrice";
import CartOffers from "../screens/discount/CartOffers";
import ProductReport from "../screens/order/orderList/Productreport";
import CancelledOrderReport from "../screens/order/orderList/Cancelledorderreport";
import SalesPivotModule from "../screens/order/orderList/Salespivotmodule";
import AiCopilotPage from "../features/ai/AiCopilotPage";

// Helper function to check if user has access to dashboard
const hasDashboardAccess = (userData) => {
  // Super admins always have access
  if (userData?.isSuperAdmin) return true;
  
  // Check if menus array exists and has dashboard
  if (userData?.menus && Array.isArray(userData.menus)) {
    // If menus array is empty, user has no access
    if (userData.menus.length === 0) return false;
    
    // Check if dashboard is in the menus
    const hasDashboardMenu = userData.menus.some(
      (menu) => menu.menu_name?.toLowerCase() === "dashboard"
    );
    return hasDashboardMenu;
  }
  
  // If no menus property, allow access (backward compatibility)
  return true;
};

// Helper function to get first accessible route
const getFirstAccessibleRoute = (userData) => {
  if (userData?.menus && Array.isArray(userData.menus) && userData.menus.length > 0) {
    // Get first menu item with a route
    const firstMenu = userData.menus.find((menu) => menu.route);
    if (firstMenu?.route) return firstMenu.route;
  }
  
  // Fallback to login
  return "/login";
};

// Protected Dashboard Component
const ProtectedDashboard = ({ userData }) => {
  if (!hasDashboardAccess(userData)) {
    const redirectPath = getFirstAccessibleRoute(userData);
    return <Navigate replace to={redirectPath} />;
  }
  return <DashboardIndex />;
};

export const ApplicationRoutes = () => {
  const userData = useSelector((state) => state.counter?.userData);

  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/login" />} />
      <Route
        path="/login"
        element={
          userData?.loggedIn ? <Navigate to="/dashboard" /> : <MainLogin />
        }
      />
      <Route
        path="/login/shop"
        element={
          userData?.loggedIn ? <Navigate to="/dashboard" /> : <LoginShop />
        }
      />

      <Route
        path="/login/dispatch"
        element={
          userData?.loggedIn ? <Navigate to="/dashboard" /> : <LoginDispatch />
        }
      />

      <Route
        path="/login/admin"
        element={
          userData?.loggedIn ? <Navigate to="/dashboard" /> : <LoginScreen />
        }
      />
      <Route exact path="/dashboard" element={<ProtectedDashboard userData={userData} />}></Route>
      {/* BF ADMIN ROUTES */}
      <Route exact path="/banner" element={<Banner />} />
      <Route exact path="/general-banner" element={<PreviewBanner />} />
      <Route path="/home-region" element={<HomeRegionSelection />} />
      <Route path="/home-section/:regionId/:city" element={<HomeSection />} />
      <Route path="/configuration" element={<Configuration />} />

      <Route path="/category" element={<Category />} />
      <Route path="/sub-category" element={<SubCategory />} />
      <Route replace path="/products" element={<Products />} />
      <Route path="/products/new-product" element={<ProductForm />} />
      <Route path="/products/edit-product/:id" element={<ProductForm />} />
      <Route
        path="/products/edit-product-image/:id"
        element={<ProductsImage />}
      />
      <Route path="/slotBlock" element={<SlotBlock></SlotBlock>} />
      <Route path="/addons" element={<Addons />} />
      <Route path="/flavour" element={<Flavour />} />
      <Route path="/order-list" element={<OrderList type="ongoing" />} />
      <Route
        path="/delivered-order-list"
        element={<OrderList type="delivered" />}
      />
      <Route
        path="/cancelled-order-list"
        element={<OrderList type="cancelled" />}
      />
      <Route path="/failed-order-list" element={<OrderList type="failed" />} />
      {/* <Route path="/order-list/:id" element={<OrderDetails />} /> */}
      <Route
        path="/order-list/:id/:type?/:orderIds?"
        element={<OrderDetails />}
      />
      <Route path="/sales-report" element={<SalesReport />} />
      <Route path="/yearly-report" element={<YearlyReport />} />

      <Route path="/dispatch-panel" element={<DispatchPanel />} />
      <Route path="/view-dispatch-order/:id" element={<ViewDispatchOrder />} />
      <Route path="/shop-panel" element={<ShopPanel />} />
      <Route path="/view-shop-order/:id" element={<ViewShopOrder />} />
      <Route path="/driver-panel" element={<DriverPanel />} />
      <Route
        path="/view-driver-order/:driverId/:orderId"
        element={<ViewDriverOrder />}
      />
      <Route path="/discount" element={<Discount />} />
      <Route path="/category-discount" element={<CategoryDiscount />} />
      <Route path="/product-discount" element={<ProductDiscount />} />
      <Route path="/promo" element={<Promo />} />
      <Route path="/customer-promo" element={<CustomerPromo />} />
      <Route path="/city" element={<City />} />
      <Route path="/location" element={<Location />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/dispatch" element={<Dispatch />} />
      <Route path="/chats" element={<Chats />} />
      <Route path="/bulk-provision" element={<Bulk />} />
      <Route path="/units" element={<Units />} />
      <Route path="/weight" element={<Weight />} />
      <Route path="/tax" element={<Tax />} />
      <Route path="/Category-code" element={<CategoryCode />} />
      <Route path="/customer-discount" element={<CustomerDiscount />} />
      <Route path="/custom-design" element={<CakeDesigner />} />
      <Route path="/SuggestionProduct" element={<SuggestionProduct />} />
      <Route path="/CampaignScreen" element={<CampaignScreen />} />
      <Route path="/campaign" element={<Campaign />} />
      <Route path="/role" element={<Role />} />
      <Route path="/team" element={<Team />} />
      <Route path="/menuCreate" element={<MenuCreate />} />
      <Route path="/ai-copilot" element={<AiCopilotPage />} />
      <Route path="/fast-delivery" element={<FastDelivery />}/>
      <Route path="/flat-price" element={<FlatPrice/>}/>
      <Route path="/cart-offers" element={<CartOffers/>}/>
      <Route path="/product-report" element={<ProductReport/>}/>
      <Route path="/cancelled-order-report" element={<CancelledOrderReport/>}/>
      <Route path="/pivot-report" element={<SalesPivotModule/>}/>

      {/* <Route path="/combo-products" element={<ComboProducts />} /> */}
      <Route
        path="/city/:id/delivery-charges"
        element={
          <AdminProvider>
            <DeliveryCharges />
          </AdminProvider>
        }
      />
    </Routes>
  );
};
